"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var styles_1 = require("./styles");
var modalRoot = typeof document !== "undefined" && (document === null || document === void 0 ? void 0 : document.getElementById("modal-root"));
var Modal = function (_a) {
    var children = _a.children, onClose = _a.onClose;
    var el = typeof document !== "undefined" && (document === null || document === void 0 ? void 0 : document.createElement("div"));
    react_1.useEffect(function () {
        if (modalRoot && el) {
            modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.appendChild(el);
        }
        return function () {
            if (modalRoot && el) {
                modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.removeChild(el);
            }
        };
    }, []);
    return el ? (react_dom_1.default.createPortal(react_1.default.createElement(styles_1.Overlay, { className: "overlay" },
        react_1.default.createElement(styles_1.ModalContainer, null,
            children,
            react_1.default.createElement(styles_1.ArrowContent, { onClick: onClose }))), el)) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.default = Modal;
